"use client";

export function HomepageBackground() {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      <div className="absolute inset-0 z-0 overflow-hidden pointer-events-none">
        {/* Clean white background - full page */}
        <div className="absolute inset-0 bg-white" />

        {/* Horizontal dashed line under header tabs */}
        <div
          className="absolute top-16 left-0 right-0 h-px z-30"
          style={{
            borderTop: "1px dashed #d1d5db",
            borderImageSource:
              "repeating-linear-gradient(to right, #d1d5db 0px, #d1d5db 4px, transparent 4px, transparent 8px)",
            borderImageSlice: 1,
          }}
        />

        {/* Full-width 6-column grid system - matches PublicBackground */}
        <div className="absolute inset-0 z-20">
          <div className="relative w-full h-full">
            
            {/* 6-Column Grid System (16.67% each) */}
            {/* Only show grid lines for the middle 4 columns on xl screens */}
            
            {/* Column 2 boundary (16.67%) - VISIBLE on xl+ */}
            <div
              className="hidden xl:block absolute top-0 w-px h-full"
              style={{
                left: "16.67%",
                borderLeft: "1px dashed #e5e7eb",
                borderImageSource:
                  "repeating-linear-gradient(to bottom, #e5e7eb 0px, #e5e7eb 4px, transparent 4px, transparent 8px)",
                borderImageSlice: 1,
              }}
            />

            {/* Column 3 boundary (33.33%) - VISIBLE on xl+ */}
            <div
              className="hidden xl:block absolute top-0 w-px h-full"
              style={{
                left: "33.33%",
                borderLeft: "1px dashed #d1d5db",
                borderImageSource:
                  "repeating-linear-gradient(to bottom, #d1d5db 0px, #d1d5db 4px, transparent 4px, transparent 8px)",
                borderImageSlice: 1,
              }}
            />

            {/* Column 4 boundary (50% - center) - VISIBLE on md+ */}
            <div
              className="hidden md:block absolute top-0 w-px h-full"
              style={{
                left: "50%",
                borderLeft: "1px dashed #d1d5db",
                borderImageSource:
                  "repeating-linear-gradient(to bottom, #d1d5db 0px, #d1d5db 4px, transparent 4px, transparent 8px)",
                borderImageSlice: 1,
              }}
            />

            {/* Column 5 boundary (66.67%) - VISIBLE on xl+ */}
            <div
              className="hidden xl:block absolute top-0 w-px h-full"
              style={{
                left: "66.67%",
                borderLeft: "1px dashed #d1d5db",
                borderImageSource:
                  "repeating-linear-gradient(to bottom, #d1d5db 0px, #d1d5db 4px, transparent 4px, transparent 8px)",
                borderImageSlice: 1,
              }}
            />

            {/* Column 6 boundary (83.33%) - VISIBLE on xl+ */}
            <div
              className="hidden xl:block absolute top-0 w-px h-full"
              style={{
                left: "83.33%",
                borderLeft: "1px dashed #d1d5db",
                borderImageSource:
                  "repeating-linear-gradient(to bottom, #d1d5db 0px, #d1d5db 4px, transparent 4px, transparent 8px)",
                borderImageSlice: 1,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
